import { PlanUpsellBanner } from 'components/shared/banners/PlanUpsellBanner';
import { BannerKey, BannerPosition, BannerType } from 'features/banner/model/banner';
import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import { useDismissBanner } from 'hooks/dismiss-banner/useDismissBanner';
import useAddonEnabled from 'hooks/plan/useAddonEnabled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { transformToCdnUrl } from 'utils/google-storage-util';
import { Feature } from '../../../../../../../../pb/subscription/v1/addon_pb';
import LabelByMonthCount from './LabelByMonthCount';

interface LabelByMonthProps {
    loading: boolean;
    hasSubscription: boolean;
}

const LabelByMonth: React.FC<LabelByMonthProps> = ({ loading: loadingData, hasSubscription }) => {
    const { t } = useTranslation();
    const { isLoading, goToPLans, planHandle } = useCurrentSubscriptionHelper();
    const { isAddonEnabled: hasPrintingLabel } = useAddonEnabled(Feature.PRINTING_SHIPPING_LABELS_ENABLED);

    // TODO: add more banner
    const { onDismiss, isDissmissed } = useDismissBanner({
        key: BannerKey.PLAN_UPSELL_BANNER,
        position: BannerPosition.DASHBOARD_PAGE,
        index: 1,
        type: BannerType.BANNER,
    });

    if (!hasSubscription && !isDissmissed) {
        return (
            <PlanUpsellBanner
                title={t('DASHBOARD.FREE_TRIAL_BANNER.TITLE')}
                description={t('DASHBOARD.FREE_TRIAL_BANNER.DESCRIPTION')}
                buttonLabel={t('DASHBOARD.FREE_TRIAL_BANNER.START_TRIAL')}
                onButtonClick={goToPLans}
                imgSrc={transformToCdnUrl('embedded-assets/svg-icons/location.svg')}
                backgroundColor={'linear-gradient(91.18deg, #19590A 3.44%, #6EBB5C 71.86%, #B8F3AA 105.32%)'}
                loading={isLoading || !goToPLans}
                onDismiss={onDismiss}
            />
        );
    }

    if (hasPrintingLabel === false && !isDissmissed) {
        return (
            <PlanUpsellBanner
                title={t('DASHBOARD.PRINTING_LABELS_DISABLED_BANNER.TITLE')}
                description={t('DASHBOARD.PRINTING_LABELS_DISABLED_BANNER.DESCRIPTION')}
                buttonLabel={t('DASHBOARD.PRINTING_LABELS_DISABLED_BANNER.UPGRADE_PLAN')}
                onButtonClick={goToPLans}
                imgSrc={transformToCdnUrl('embedded-assets/svg-icons/rocket.svg')}
                backgroundColor={'linear-gradient(91.18deg, #002095 -0.17%, #1F4AE7 48.12%, #CEC2FF 105.32%)'}
                loading={isLoading || !goToPLans}
                onDismiss={onDismiss}
            />
        );
    }

    if (planHandle !== 'plus' && planHandle !== 'plus-test' && !isDissmissed) {
        return (
            <PlanUpsellBanner
                title={t('DASHBOARD.LOWER_LABEL_COST_BANNER.TITLE')}
                description={t('DASHBOARD.LOWER_LABEL_COST_BANNER.DESCRIPTION')}
                buttonLabel={t('DASHBOARD.LOWER_LABEL_COST_BANNER.CHANGE_PLAN')}
                onButtonClick={goToPLans}
                imgSrc={transformToCdnUrl('embedded-assets/svg-icons/payment-capture.svg')}
                backgroundColor={'linear-gradient(91.18deg, #002095 -0.17%, #1F4AE7 48.12%, #CEC2FF 105.32%)'}
                loading={isLoading || !goToPLans}
                onDismiss={onDismiss}
            />
        );
    }

    return <LabelByMonthCount loading={isLoading || loadingData} />;
};

export default LabelByMonth;
